function productSlickCarousel() {


  $("#Slider-signup-page").slick({ 
    dots: !1, 
    autoplay: false,
    pauseOnHover: !1, 
    fade: !1, 
    infinite: false, 
    arrows: true, 
    slidesToShow: 2.5, 
    slidesToScroll: 1, 
    easing: "ease", 
    vertical: false,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="" aria-disabled="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'

  });
}

document.getElementById("sale-page--form").addEventListener("submit", function(event) {
    event.preventDefault();
  
    // Check if all required fields are filled
    var requiredFields = event.target.querySelectorAll('input[required], select[required], textarea[required]');
    var isFormValid = true;
    requiredFields.forEach(function(field) {
      if (field.value.trim() === '') {
        isFormValid = false;
        field.classList.add('error');
      } else {
        field.classList.remove('error');
      }
    });
  
    if (!isFormValid) {
      //console.log('Test');
      return false;
    }
  
    var formData = new FormData(event.target);
    var data = {};
    for (var [key, value] of formData.entries()) {
      data[key] = value;
    }
    fetch("https://krw-klav.herokuapp.com/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data),
    })
    .then(response => {
      if (response.status === 200) {
       // console.log('Thanks for subscribing');
  
        $(".form--step-1").addClass("form--hidden-step");
        $(".form--step-3").removeClass("form--hidden-step");

      
  
        setTimeout(function () {
          $("html, body").animate({ scrollTop: 0 });
        }, 1000);
  
        // Update success images
        var successMobileImage = document.querySelector(".about--pillar-left img[data-success-mobile-image]");
        var successDesktopImage = document.querySelector(".about--pillar-left[data-success-desktop-image]");
        if (successMobileImage) {
          successMobileImage.src = successMobileImage.dataset.successMobileImage;
          $('.tooltip-on-image').css('display', 'block')
        }
        if (successDesktopImage) {
          successDesktopImage.style.backgroundImage = "url(" + successDesktopImage.dataset.successDesktopImage + ")";
        }
  
        // setup some local variables
        var $form = $("#sale-page--form");
        setTimeout (function(){
              $('.sale--products').fadeIn(300);
              if ($('body').hasClass('template-private-event-sign-up') && $(window).width() > 990 || $('body').hasClass('template-international-private-event-sign-up') && $(window).width() > 990) {

                setTimeout(function() {
                  productSlickCarousel();
                },100);
              }
              if ($('body').hasClass('template-private-event-sign-up') && $(window).width() < 990 || $('body').hasClass('template-international-private-event-sign-up') && $(window).width() < 990) {
                setTimeout(function () {
                  updateCarousels();
                }, 1000);
              }
        }, 500);

        if (!$('.klav-ajax-form').hasClass('klav-email-only-form')) {
        
    
          var $email = $form.find('input[name="email"]').val().toLowerCase(),
              $countryCode = $form.find(".iti__selected-dial-code").text(),
              $enteredNumber = $form.find(".sale--number").val().toLowerCase(),
              $combinedNumber = $countryCode + $enteredNumber,
              $phone_number = $combinedNumber.trim();
    
          
          var attentiveData = {
            user: {
              phone: "" + $phone_number + "",
              email: "" + $email + "",
            },
            signUpSourceId: "" + window.signupPageData.attentiveID + "",
          };
    
    
          if ($(".iti__flag").hasClass("iti__us")) {
            $.ajax({
              type: "POST", // define the type of HTTP verb we want to use (POST for our form)
              url: "https://krw-attve.herokuapp.com/attve-v2.php", // the url where we want to POST
              data: JSON.stringify(attentiveData), // our data object
              dataType: "json", // what type of data do we expect back from the server
            });
    
            setTimeout(function(){
              console.log('Source ID: ' + attentiveData.signUpSourceId);
            },1000);
          }

        } 

        //console.log(response);
  
      } else {
        console.log('Error subscribing 1');
        //console.log(response);
      }
    })
    .catch(error => {
      //console.log('Error subscribing 2');
      console.log(error);
      //console.log(response);
    });
  });
  

  function updateCarousels() {
    console.log('updateCarousels called');
    document.querySelectorAll('main .plp-carousel').forEach((carousel) => {
        const carouselId = carousel.dataset.carouselId;
        const slides = Array.from(carousel.querySelectorAll('img')); // Create an array of slides
        const track = document.querySelector(`main .carousel-track-wrapper[data-carousel-id="${carouselId}"] .carousel-track`);
        const rectangle = track.querySelector('.carousel-rectangle');

        rectangle.style.width = `${track.offsetWidth / slides.length}px`;

        const trackWidth = track.offsetWidth - rectangle.offsetWidth;

        carousel.addEventListener('scroll', () => {
            const scrollLeft = carousel.scrollLeft;
            const scrollWidth = carousel.scrollWidth;
            const carouselWidth = carousel.offsetWidth;
            const scrollPercent = scrollLeft / (scrollWidth - carouselWidth);

            rectangle.style.transform = `translateX(${scrollPercent * trackWidth}px)`;

        });
    });
}